import React from 'react'
import classes from './CompanyInfo.module.css'
import SubSectionHeader from '../../../Shared/SubSectionHeader'
import NoRecordFound from '../../../Shared/NoRecordFound'
import Input from '../../../Shared/Forms/Input'
import Dropdown from '../../../Shared/Forms/Dropdown'
import { replaceValueForKey } from '../../../../Utility'
import { Constants } from '../../../../Constants'
import cloneDeep from 'lodash.clonedeep'
const CompanyInfo = ({
    transporterInfo,
    isEditable
}) => {
    const EditMode = ({ transporterInfo }) => {

        const bankDetails = transporterInfo && transporterInfo.bank_details;
        return (
            <>
                <div
                    className={
                        classes['margin-top10px'] + ' ' + classes['flex-direction-row']
                    }
                >
                    <span className={classes['field-label'] + ' ' + classes['font-color']}>Corporate Identity Number (CIN):</span>
                    <Input
                        onChange={value => {
                            replaceValueForKey(bankDetails, 'cin_number', value);
                        }}
                        className={classes['input-box-height']}
                        defaultValue={bankDetails && bankDetails.cin_number}
                    />
                </div>
                <div
                    className={
                        classes['margin-top10px'] + ' ' + classes['flex-direction-row']
                    }
                >
                    <span className={classes['field-label'] + ' ' + classes['font-color']}> Company PAN card No:</span>
                    <Input
                        maxLength={10}
                        onChange={value => {
                            replaceValueForKey(bankDetails, 'pan_card', value);
                        }}
                        className={classes['input-box-height']}
                        defaultValue={bankDetails && bankDetails.pan_card}
                    />
                </div>
                <div
                    className={
                        classes['margin-top10px'] + ' ' + classes['flex-direction-row']
                    }
                >
                    <span className={classes['field-label'] + ' ' + classes['font-color']}>Incorporated under Companies Act:</span>
                    <Dropdown
                        defaultValues={cloneDeep(Constants.CompanyAct).filter(
                            a => a.value === transporterInfo.company_act
                        )}
                        picklistOptions={cloneDeep(Constants.CompanyAct)}
                        onValueChange={selected =>
                            replaceValueForKey(transporterInfo, 'company_act', selected.value)
                        }
                        placeholder="Select company Act"
                        className={classes['padding-0'] + ' ' + classes['width30Per']}
                        isSearchable={false}
                    />
                </div>

            </>
        )
    }
    const ReadMode = ({ transporterInfo }) => {
        const bankDetails = transporterInfo && transporterInfo.bank_details;
        return (
            <>
                <div className={classes['flex-direction-row']}>
                    <div className={classes['flex-left']}>
                        <span
                            className={classes['field-label'] + ' ' + classes['font-color']}
                        >
                            Company PAN Card No:
                        </span>
                        <span className={classes['font-color']}>
                            {bankDetails && bankDetails.pan_card ? (
                                bankDetails.pan_card
                            ) : (
                                    <NoRecordFound message={'--'}></NoRecordFound>
                                )}
                        </span>
                    </div>
                    <div className={classes['flex-right']}>
                        <span
                            className={classes['field-label'] + ' ' + classes['font-color']}
                        >
                            Incorporated Under Companies Act:
                        </span>
                        <span className={classes['font-color']}>
                            {transporterInfo && transporterInfo.company_act ? (
                                transporterInfo.company_act
                            ) : (
                                    <NoRecordFound message={'--'}></NoRecordFound>
                                )}
                        </span>
                    </div>
                </div>

                <div className={classes['flex-direction-row']}>
                    <div className={classes['flex-left']}>
                        <span
                            className={classes['field-label'] + ' ' + classes['font-color']}
                        >
                            Corporate Identity Number (CIN):
                        </span>
                        <span className={classes['font-color']}>
                            {bankDetails && bankDetails.cin_number ? (
                                bankDetails.cin_number
                            ) : (
                                    <NoRecordFound message={'--'}></NoRecordFound>
                                )}
                        </span>
                    </div>
                </div>
            </>)
    }
    return (
        <div className={classes['width100Per']}>
            <SubSectionHeader title="Company Details"></SubSectionHeader>
            {isEditable ?
                <EditMode transporterInfo={transporterInfo} /> :
                <ReadMode transporterInfo={transporterInfo} />}

        </div>
    )
}


export default CompanyInfo
